import type { WebGLRenderer } from 'three';
import type { QualitySettings } from '../../../../hooks/use-three-kitchen/quality';

/**
 * Configuration for TextureManager
 */
export interface TextureManagerConfig {
	/** Base path for texture assets */
	basePath: string;
	/** Render quality (0-10) */
	renderQuality: number;
	/** Texture quality tier. null/undefined = follow renderQuality. */
	textureQuality?: number | null;
	/** WebGL renderer for anisotropy */
	renderer: WebGLRenderer | null;
	/** Quality settings */
	qualitySettings: QualitySettings | null;
	/** URL path to the Basis Universal transcoder WASM files for KTX2 support */
	ktx2TranscoderPath?: string;
}

/**
 * Callbacks for texture loading
 */
export interface TextureLoadCallbacks {
	onComplete?: () => void;
	onProgress?: (loaded: number, total: number) => void;
	onError?: (url: string) => void;
}

/**
 * Base emissive intensity for materials
 */
export const BASE_EMISSIVE = 0.4;
